export class MessageText {
  constructor(text) {
    this.messageType = 'TEXT';
    this.text = text;
  }
}
export class MessageCard {
  constructor(card) {
    this.messageType = 'CARD';
    this.card = card;
  }
}
export class MessageCardCarousel {
  constructor(carousel) {
    this.messageType = 'CAROUSEL';
    this.carousel = carousel;
  }
}
export class MessageAccordion {
  constructor(accordion) {
    this.messageType = 'ACCORDION';
    this.accordion = accordion;
  }
}
export class MessageEmbeddedMedia {
  constructor(media) {
    this.messageType = 'MEDIA';
    this.media = media;
  }
}
export class MessageFileLink {
  constructor(file, link) {
    this.messageType = 'FILE_LINK';
    this.file = file;
    this.link = link;
  }
}
export class MessageSuggestions {
  constructor(suggestions) {
    this.messageType = 'SUGGESTIONS';
    this.suggestions = suggestions;
  }
}
export class MessageUrl {
  constructor(link) {
    this.messageType = 'URL';
    this.link = link;
  }
}
//# sourceMappingURL=messages-models.js.map
